import { render, staticRenderFns } from "./Registor.vue?vue&type=template&id=87246a88&scoped=true"
import script from "./Registor.vue?vue&type=script&lang=js"
export * from "./Registor.vue?vue&type=script&lang=js"
import style0 from "./Registor.vue?vue&type=style&index=0&id=87246a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87246a88",
  null
  
)

export default component.exports